import React from "react";
import NumberDisplay from "../../../../components/numberDisplay/numberDisplay";
import { useSelector } from "react-redux";

const PrevProfilesCreatedMonthToDate = () => {
  const { prevYearProfilesCreatedMTD, prevProfilesCreatedRawDataLink } = useSelector(
    (state) => state.leadsAdded.leads
  );
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  return (
    <NumberDisplay
      value={prevYearProfilesCreatedMTD}
      url={prevProfilesCreatedRawDataLink}
      disableAnimation={isUserQa}
    />
  );
};

export default PrevProfilesCreatedMonthToDate;
